<template>
  <div class="d-flex align-center">
    <div :class="{redPoint: required,  transparentPoint: !required}"></div>
    <v-input :class="{'v-album-text': true, 'd-flex': true, 'pa-5': true, reminder: reminding}" hideDetails>
      <input
        class="text-input"
        type="text"
        v-bind:value="value"
        v-on:input="updateValue($event.target.value)"
        :placeholder="placeholder"
      />
      <div v-if="description != null" class="ml-auto textcolor9--text">{{ description }}</div>
      <div v-if="reminding == true" style="width: 40px;" class="ml-auto remindercolor--text">{{ $t('global.text.required') }}</div>
      <div v-if="reminding !== true && language != null" style="width: 40px;" class="ml-auto textcolor9--text">* {{ language }}</div>
    </v-input>
  </div>
</template>

<script>
export default {
  name: "MTextInput",
  data() {
    return {
    };
  },
  created: function() {},
  props: {
    value: { type: String },
    placeholder: String,
    required: {
      type: [Boolean],
      default: false
    },
    language: String,
    description: String,
    reminding: Boolean
  },

  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style scoped>
.v-album-text {
    background-color: #F9FAFC;
    /* border-color: #E3E3E3; */
    border-color: #BDBEC0;
    border-radius: 4px;
    border-style: solid;
    border-width: 1px;
}

.v-album-text {
  margin-left: 20px;
  width: 400px;
}

.text-input {
    width: 100%;
}

.redPoint {
  background-color: #e62e2e;
  border-radius: 3.5px;
  width: 7px;
  height: 7px;
}
.transparentPoint {
  background-color: transparent;
  border-radius: 3.5px;
  width: 7px;
  height: 7px;
}

.reminder {
    border-color: #E62E2E;
    border-width: 2px;
}
</style>




